
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(170|526|572|912)|24(57|66)|5(6(|6|9)1|730)|6(396|545|770)|8(036|042|252|728)|7(00|70|98)|3(346|488|573|813)|1000|193|9081)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
